<template>
    <div class="speechToText">
        <div class="start" :class="{'disable': disableSpeech}" v-if="!listening" @click="start()"></div>
        <div class="stop" :class="{'disable': disableSpeech}" v-if="listening" @click="stop()"></div>
    </div>
</template>

<script>

const CONFIDENCE_THRESHOLD = 0.75;

/* eslint-disable no-console */
export default {
    name: 'SpeechToText',
    props: {
        value: String,
        disableSpeech: Boolean,
        lang: {
            type: String,
            default: 'it-IT'
        },
        continuous: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return{
            listening: false,
            recognition: null
        }
    },
    created() {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        
        if (SpeechRecognition) {
            let self = this;

            self.recognition = new SpeechRecognition();
            self.recognition.lang = self.lang;
            self.recognition.continuous = true;
            self.recognition.interimResults = true;
            self.recognition.addEventListener("result", event => {
                self.onResult(event);
            });
        }

    },
    methods:{       
        stop() {
            this.listening = false;
            this.recognition.stop();
            this.$root.$emit('speech-to-text.stop');
        },

        start() {
            this.listening = true;
            this.recognition.start();
            this.$root.$emit('speech-to-text.start');
        },

        onResult(event) {
            for (const res of event.results) {
    
                if (res[0].confidence > CONFIDENCE_THRESHOLD) {
                    this.$emit('input', res[0].transcript);
                }

                if (res.isFinal) {
                    this.$emit('input', res[0].transcript);
                    this.$root.$emit('speech-to-text.final');
                    if (!this.continuous) {
                        this.stop();
                    }
                }
            }
        }
    }
};
</script>

<style lang="scss">
.speechToText {
    & > div{
        min-width: 25px;
        min-height: 100%;
        background-repeat: no-repeat;
        background-position: center;
        color: #c1c1c1;
        &.disable{
            opacity: .5;
            pointer-events: none;
        }
    }
    .start {
        background-image: url("/frontend/img/ico_microphone_slash.svg");
        background-size: 24px;
        
    }

    .stop {
        background-image: url("/frontend/img/ico_microphone.svg");
        background-size: 18px;
    }    
}
</style>